import app from '../../../main'

export default {
    namespaced: true,
    state: {
        retailer: null,
        retailers: [],
        mobileRetailers: [],
        pagination: {
            page: 1,
            totalPages: 1,
            totalProducts: 0,
            pageSize: 10
        },
        errors: {
            getRetailers: {}
        }
    },
    mutations: {
        SET_ERRORS(state, error) {
            state.errors[error.key] = error.val
        },
        CLEAR_RETAILERS(state) {
            state.retailers = []
            state.mobileRetailers = []
            state.pagination = {
                page: 1,
                totalPages: 1,
                totalProducts: 0,
                pageSize: 10
            }
        },
        SET_RETAILERS(state, payload) {
            state.retailers = payload
        },
        SET_RETAILER(state, payload) {
            state.retailer = payload
        },
        SET_MOBILE_RETAILERS(state, payload) {
            if (state.pagination.page == 1) {
                state.mobileRetailers = payload
            } else {
                state.mobileRetailers = [...state.mobileRetailers, ...payload]
            }
        },
        SET_PAGINATION(state, payload) {
            state.pagination[payload.key] = payload.val
        }
    },
    actions: {
        clearRetailers({ commit }) {
            commit('CLEAR_RETAILERS')
        },
        async getRetailer({ commit, state }, data) {
            commit('SET_ERRORS', {
                key: 'getRetailer',
                val: {}
            })

            const url = '/supplier/statistics/global/retailers'

            try {
                const resp = await this.$axios.get(url, {
                    params: {
                        id: data
                    }
                })
                app.$Progress.finish()

                commit('SET_RETAILER', resp.data)
            } catch (e) {
                app.$Progress.fail()
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getRetailer',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getRetailer',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        },
        async getRetailers({ commit, state }, data) {
            commit('SET_ERRORS', {
                key: 'getRetailers',
                val: {}
            })

            const url = '/supplier/statistics/global/retailers'

            try {
                const resp = await this.$axios.get(url, {
                    params: {
                        ...data,
                        items: state.pagination.pageSize
                    }
                })
                app.$Progress.finish()

                commit('SET_RETAILERS', resp.data)

                commit('SET_PAGINATION', {
                    key: 'page',
                    val: resp.headers['page'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'totalPages',
                    val: resp.headers['total-pages'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'totalProducts',
                    val: resp.headers['total-records'] * 1
                })
                commit('SET_PAGINATION', {
                    key: 'pageSize',
                    val: resp.headers['page-size'] * 1
                })

                if (
                    (data && data.isMobilePagination) ||
                    state.pagination.page == 1
                ) {
                    commit('SET_MOBILE_RETAILERS', resp.data)
                }
            } catch (e) {
                app.$Progress.fail()
                if (e.response && e.response.data) {
                    console.log(e.response.data)
                    commit('SET_ERRORS', {
                        key: 'getRetailers',
                        val: e.response.data
                    })
                } else {
                    console.log('Ошибка ' + e.message)
                    commit('SET_ERRORS', {
                        key: 'getRetailers',
                        val: { error: 'Ошибка' }
                    })
                }
            }
        }
    }
}
